import createNetworkingClient from 'utils/networking-client';
import { FOLLOWING_STATUS } from '../../constants/follows/following-constants';

/**
 *  Follows an athlete on strava.
 *
 * @param {Object} param
 * @param {string} param.followerId - id for the athlete who is requesting the follow
 * @param {string} param.followingId - id for the athlete to be followed
 * @returns {Promise<FOLLOWING_STATUS>} - enum value PENDING or FOLLOWING
 */
export const followAthlete = ({ followerId, followingId }) => {
  return new Promise((resolve) => {
    createNetworkingClient()
      .post(`/athletes/${followerId}/follows`, {
        follow: {
          follower_id: followerId,
          following_id: followingId
        }
      })
      .then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          if (data.approved) {
            resolve(FOLLOWING_STATUS.following);
          } else {
            resolve(FOLLOWING_STATUS.pending);
          }
        } else {
          resolve(FOLLOWING_STATUS.error);
          // TODO log sentry error
        }
      })
      .catch(() => {
        resolve(FOLLOWING_STATUS.error);
        // TODO log sentry error
      });
  });
};

export default { followAthlete };
